<template>
  <ConfigProvider>
    <NuxtRouteAnnouncer />
    <ToastWrapper />
    <NuxtLoadingIndicator />
    <DynamicDialog />
    <NuxtLayout>
      <div
        v-if="loading"
        class="flex fixed top-0 left-0 z-40 justify-center items-center w-full h-screen bg-white"
      >
        <AtomsLoader />
      </div>
      <NuxtPage ref="page" />
    </NuxtLayout>
  </ConfigProvider>
</template>

<script setup>
import "@/utils/string";
import "@/utils/arrayCustomFunction";

const page = ref();
const nuxtApp = useNuxtApp();
const loading = ref(false);
const { initializeThemeColors } = useUserThemeColors();

initializeThemeColors();

nuxtApp.hook("page:start", () => {
  loading.value = true;
});
nuxtApp.hook("page:finish", () => {
  loading.value = false;
});
</script>
